"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _InputField = _interopRequireDefault(require("../../FormControlFragments/InputField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardInput = function CardInput(props) {
  return /*#__PURE__*/_react.default.createElement(_InputField.default, _extends({}, props, {
    type: "text",
    autoComplete: "cc-number",
    autoCorrect: "off",
    autoFormat: "card",
    inputMode: "decimal",
    maxLength: 19,
    pattern: "^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$"
  }));
};

var _default = CardInput;
exports.default = _default;